<template>
	<div id="ChurchModalComponent">
		<button class="btn-link" data-toggle="modal" data-target="#churchModalComponent" ref="btnShowChurchModalComponent" v-show="false">Editar Iglesia</button>

		<div class="modal fade" id="churchModalComponent" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">{{objectChurch.type_church.name}} {{objectChurch.name}} ({{idLocal}})</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="row">
							<div class="col-md-2">
								<div class="form-group">
									<label for="inputName">Tipo</label>
									<input type="text" class="form-control form-control-sm" v-model='objectChurch.type_church.name' placeholder="Tipo" readonly>
								</div>
							</div>
							<div class="col-md-8">
								<div class="form-group">
									<label for="inputName">Nombre</label>
									<input type="text" class="form-control form-control-sm" v-model='objectChurch.name' placeholder="Nombre" readonly>
								</div>
							</div>
							<div class="col-md-2">
								<div class="form-group">
									<label for="inputName">Genesys</label>
									<input type="text" class="form-control form-control-sm text-right" v-model='clicod' placeholder="" readonly>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-3">
								<div class="form-group">
									<label for="inputName">Distrito</label>
									<input type="text" class="form-control form-control-sm" v-model='objectChurch.district.name' placeholder="Tipo" readonly>
								</div>
							</div>
							<div class="col-md-9">
								<div class="form-group">
									<label for="inputName">Campo</label>
									<input type="text" class="form-control form-control-sm" v-model='objectChurch.entity.name' placeholder="Nombre" readonly>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-12">
								<div class="form-group">
									<label for="inputName" class="margin-right5">Coordinador</label>
									<small class="far fa-edit text-mute pointer" title="Editar" @click="objectChurch.client = null" v-if="objectChurch.client != null"></small>
									<input type="text" class="form-control form-control-sm" v-if="objectChurch.client != null" v-model="client" placeholder="Nombre" readonly :title="objectChurch.client_id">
									<autocomplete-input-component
										v-else
										_class="form-control form-control-sm"
										:_path="apiBackend + 'clients'"
										@actionSelectItem="setClientLocal"></autocomplete-input-component>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-12">
								<div class="form-group">
									<label for="inputName">Vinculaciones</label> ({{listChurchClient.length}})
									<div class="overflow-auto"  style="height:200px">
										<table class="table table-sm table-12">
											<thead>
												<tr>
													<th class="text-center">ID</th>
													<th class="text-center">Nombre</th>
													<th class="text-center">Apellido</th>
													<th class="text-center">Email</th>
													<th class="text-center">Telefono</th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(item, index) in listChurchClient" :key="index">
													<td class="text-center">{{ item.id }}</td>
													<td>{{ item.name }}</td>
													<td>{{ item.surname }}</td>
													<td>{{ item.email }}</td>
													<td class="text-center">{{ item.phone }}</td>
													<td class="text-right">
														<i class="far fa-circle text-secundary pointer" v-if="(objectChurch.genesys == null) || (objectChurch.client_id != item.id)" title="Seleccionar" @click="selectClientLocal(item)"></i>
														<i class="far fa-check-circle text-primary" v-else title="Seleccionado"></i>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-primary btn-sm" @click="saveChurchLocal">Guardar</button>
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">Cerrar</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import errors from '@/mixins/errors.js'
	import axiosAction from '@/mixins/axiosAction.js'
	import churchs from '@/mixins/generals/church.js'

	import AutoCompleteInputComponent from '@/components/AutoCompleteInputComponent.vue'
	export default {
		name: 'ChurchModalComponent',
		mixins: [axiosAction, errors, mixin, churchs],
		props:['id'],
		data () {
			return {	
			}
		},
		computed: {
			idLocal() {
				if(this.id != 0) {
					this.showChurchLocal(this.id)
				}
				return this.id
			},
			clicod() {
				return (this.objectChurch.genesys === null) ? '' : this.objectChurch.genesys.clicod
			},
			client() {
				return this.objectChurch.client.name + ' ' + this.objectChurch.client.surname
			}
		},
		methods: {
			resultAxiosLocal(responseLocal, response) {
				this.$emit('hideLockScreen')
				switch(responseLocal) {
					case 'getAllChurchClientsResult': this.getAllChurchClientsResult(response); break;
					case 'saveChurchResult': this.saveChurchResult(response); break;
					case 'showChurchResult': this.showChurchResult(response); break;
					default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
				}
			},
			getAllChurchClientsResultLocal(response) {

			},
			saveChurchLocal() {
				this.saveChurch(this.objectChurch)
			},
			saveChurchResultLocal(response) {
				if(response.data.success == true) {
					this.$emit('actionSaveChurch', response.data)
				}
			},
			selectClientLocal(item) {
				this.setClientLocal({id: item.id, item: item})
			},
			setClientLocal(data) {
				this.objectChurch.client_id = data.id
				this.objectChurch.client = data.item
			},
			showChurchLocal(id) {
				this.listChurchClient = []
				this.clearObjectChurch()
				this.showChurch(id)
			},
			showChurchResultLocal(response) {
				if(response.data.success == true) {
					this.getAllChurchClients(this.objectChurch.id)
				}
			},
		},
		components: {
			'autocomplete-input-component': AutoCompleteInputComponent,
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
